import { Box, IconButton, styled } from '@mui/material';
import { Handle, Node, Position } from '@xyflow/react';
import { NodeProps } from '@xyflow/system';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import { HandleId } from './WorkflowStepNode';
import { useEffect, useRef } from 'react';

type WorkflowAddButtonNodeData = {
  row: number;
  title: string;
  parentId: string;
  isAddButton?: boolean;
  onHeightChange?: (id: string, height: number) => void;
};

type AddButtonNode = Node<WorkflowAddButtonNodeData, 'addButton'>;

const PREFIX = 'WorkflowAddButtonNode';

const classes = {
  handle: `${PREFIX}-handle`,
  addButton: `${PREFIX}-addButton`,
};

const StyledBox = styled(Box)(({ theme }) => ({
  [`& .${classes.handle}`]: {
    opacity: 0,
  },
  [`& .${classes.addButton}`]: {
    marginTop: -5,
    color: theme.palette.primary.main,
  },
}));

export default function WorkflowAddButtonNode({
  id,
  data,
}: NodeProps<AddButtonNode>) {
  const nodeRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (nodeRef.current) {
      const observer = new ResizeObserver(() => {
        const height = nodeRef.current?.offsetHeight;
        data.onHeightChange?.(id, height ?? 0);
      });

      observer.observe(nodeRef.current);

      data.onHeightChange?.(id, nodeRef.current.offsetHeight);

      return () => observer.disconnect();
    }
  }, [data]);

  return (
    <StyledBox ref={nodeRef}>
      <Handle
        type="target"
        id={HandleId.TopCenter}
        position={Position.Top}
        className={classes.handle}
      />
      <IconButton size="small" className={classes.addButton}>
        <AddCircleOutlineOutlinedIcon />
      </IconButton>
    </StyledBox>
  );
}
